import { Box, Container, Typography } from "@mui/material";
import SEO from "../components/Common/SEO";


export default function PrivacyPolicy() {
  return (
    <>
      <SEO page="privacy" />

      <Box
        sx={{
          background:
            "linear-gradient(180deg,#F8FBFF 0%,#FFFFFF 100%)",

          minHeight: "100vh",

          py: {
            xs: 6,
            md: 10,
          },
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              p: {
                xs: 3,
                md: 6,
              },

              borderRadius: "30px",

              background: "#fff",

              border: "1px solid rgba(0,87,255,.08)",

              boxShadow:
                "0 20px 60px rgba(0,87,255,.08)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,

                color: "#07122F",

                fontSize: {
                  xs: "34px",
                  md: "56px",
                },
              }}
            >
              Privacy Policy
            </Typography>

            <Typography
              sx={{
                color: "#64748B",

                mt: 1,

                mb: 5,
              }}
            >
              Last Updated: June 2026
            </Typography>

            {[
              {
                title: "Information We Collect",
                text:
                  "We may collect your name, phone number, email address, pickup and delivery address, and service inquiries submitted through our website.",
              },

              {
                title: "How We Use Information",
                text:
                  "Information is used to process service requests, arrange pickups and deliveries, communicate regarding orders, improve customer experience, and provide support.",
              },

              {
                title: "Information Sharing",
                text:
                  "We do not sell, rent, or trade personal information. Information may only be disclosed when required by law or necessary to provide requested services.",
              },

              {
                title: "Data Security",
                text:
                  "We implement reasonable security measures to protect customer information from unauthorized access, disclosure, or misuse.",
              },

              {
                title: "Cookies & Analytics",
                text:
                  "Our website may use cookies and analytics tools to improve performance, user experience, and website functionality.",
              },

              {
                title: "Third-Party Links",
                text:
                  "This website may contain links to third-party websites such as Google Maps or social media platforms. We are not responsible for their privacy practices.",
              },

              {
                title: "Your Rights",
                text:
                  "You may request access, correction, or deletion of your personal information by contacting us.",
              },

              {
                title: "Contact Information",
                text:
                  "Comet Cleaners, 15 Westney Rd N Unit 4A, Ajax, Ontario L1T 1P5. Email: cometcleaners5@gmail.com",
              },
            ].map((item, index) => (
              <Box key={index} sx={{ mb: 4 }}>
                <Typography
                  sx={{
                    fontWeight: 800,

                    color: "#07122F",

                    mb: 1,

                    fontSize: {
                      xs: "20px",
                      md: "26px",
                    },
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: "#64748B",

                    lineHeight: 1.9,
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
}
